import { ConfluenceEdition } from '@confluence/change-edition';

type IsFeatureEnabledForEditionParams = {
	edition: ConfluenceEdition | null;
};

export const isTrialComponentsEnabledForEdition = ({
	edition,
}: IsFeatureEnabledForEditionParams): boolean => {
	return edition === ConfluenceEdition.STANDARD || edition === ConfluenceEdition.PREMIUM;
};
